import React, { useEffect, useState } from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import styles from './choice.module.css';

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

/** − value + : steps by one within `min` and `max`; a typed number applies on Enter or blur, anything else snaps back. */
export const Stepper = ({ label, value, min, max, onChange }) => {
    const [draft, setDraft] = useState(String(value));
    useEffect(() => setDraft(String(value)), [value]);

    const commit = () => {
        const typed = Number.parseFloat(draft);
        if (Number.isFinite(typed)) onChange(clamp(Math.round(typed), min, max));
        else setDraft(String(value));
    };

    return (
        <span className={styles.stepperField}>
            <button
                type="button"
                className={styles.stepperBtn}
                aria-label={`Decrease ${label.toLowerCase()}`}
                disabled={value <= min}
                onClick={() => onChange(clamp(value - 1, min, max))}
            >
                <RemoveIcon />
            </button>
            <input
                className={styles.stepperInput}
                inputMode="numeric"
                aria-label={label}
                value={draft}
                onChange={(event) => setDraft(event.target.value)}
                onBlur={commit}
                onKeyDown={(event) => event.key === 'Enter' && event.currentTarget.blur()}
            />
            <button
                type="button"
                className={styles.stepperBtn}
                aria-label={`Increase ${label.toLowerCase()}`}
                disabled={value >= max}
                onClick={() => onChange(clamp(value + 1, min, max))}
            >
                <AddIcon />
            </button>
        </span>
    );
};
